import { JobPosition } from '@pflegia/types/api/job-position/job-position';
import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';

export const getFunnelPropsData = <P extends { jobPosition: JobPosition; sourceDomain: SourceDomain }>(props: P) => {
  const { jobPosition, sourceDomain } = props;
  const isPraxia = sourceDomain === SourceDomain.PraxiaDe;
  const employerCareType = jobPosition?.employer?.careType;

  return { employerCareType, isPraxia };
};
